import React, { useEffect, useState } from "react";
import { Divider } from "antd";
import moment from "moment";
import { formatValidInput, formatValidSelect } from "../../helpers/FormatHelper";
import DynamicSelect from "../shared/DynamicSelect";
import TimePicker from "../shared/TimePicker";
import DatePicker from "../shared/DatePicker";
import { getLocationsByCustomer } from "../../networking/NetworkingCustomers";
import NumberInput from "../shared/NumberInput";
import { getBNCrossRate } from "./OrderService";
import DynamicSelectWithSearch from "../shared/DynamicSelectWithSearch";

export function OrderInformationHeader({
  customerName,
  customerID,
  validations,
  locationCustomerID,
  date,
  time,
  deliveryMethodSelected,
  deliveryMethodList,
  lockedSide,
  settlementCurrenciesList, 
  buyCurrencySelected,
  crossR,
  updateDeliveryDate,
  updateDeliveryTime,
  updateDeliveryTo,
  updateDeliveryMethod,
  updateBuyCurrency,
  totalOrder,
  instruments,
  settlementMethods,
  updateField,
  defaultInstrument, 
  defaultSettlementMethod,
  selectedtInstrument, 
  selectedSettlementMethod
}) {
  const format = 'HH:mm';
  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [deliveryTime, setDeliveryTime] = useState(null);
  const [deliveryCustomerID, setDeliveryCustomerID] = useState(0);
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [buyCurrency, setBuyCurrency] = useState('');
  const [firstLoad, setFirstLoad] = useState(true);
  const startDate = new Date();
  startDate.setDate(startDate.getDate() + 1);
    const [showCompanyAddress, setShowCompanyAddress] = useState(false);
    const companyAddress = localStorage.getItem('BNCompany Address');
  const [locationsList, setLocationsList] = useState([]);
  const [settlementMethodsFilter, setSettlementMethodsFilter] = useState([]);
    const [isPartnerPickUp, setIsPartnerPickUp] = useState(false);
    const baseCCy = localStorage.getItem('BNBase Currency');
  const [crossRate, setCrossRate] = useState(0);
  const [ratePrecision, setRatePrecision] = useState(8);
  const [instrument, setInstrument] = useState('');
  const [settlementMethod, setSettlementMethod] = useState('');



  const handleChangeDeliveryDate = (dateValue) => {
    setDeliveryDate(dateValue);
    updateDeliveryDate(dateValue);
  };

    useEffect(()=>{    
    const startDate = date? new Date(date) :new Date();
    const hours = String(startDate.getHours()).padStart(2, '0');
    const minutes = String(startDate.getMinutes()).padStart(2, '0');
    //const timeDelivery = time? moment(time, format): moment(`${hours}:${minutes}`, format);
    //setDeliveryTime(timeDelivery);  

    startDate.setHours(0, 0, 0, 0);
    setDeliveryDate(startDate);
  },[date])

  
  useEffect(()=>{
    if(buyCurrencySelected !== '')
    {
      setBuyCurrency(buyCurrencySelected);
    }
  },[buyCurrencySelected])

  useEffect(()=>{
    if(crossR !== '')
    {
      setCrossRate(crossR);
    }
  },[crossR])


   useEffect(()=>{
    if(deliveryMethodSelected && deliveryMethodSelected !== '' && firstLoad)
    {
      if(date !== null && date !== '')
      {
        //setDeliveryTime(moment(time, format));
        setDeliveryDate(new Date(date));
      }

      setDeliveryMethod(deliveryMethodSelected);
      setShowCompanyAddress((lockedSide.toLowerCase() === 'buy' && deliveryMethodSelected.toLowerCase().includes('sends currency')));
      setIsPartnerPickUp((lockedSide.toLowerCase() === 'buy' && deliveryMethodSelected.toLowerCase().includes('partner pick')));

      const loadLocations = async (deliveryMethodSelected, deliveryFeeId) => {    
          if(deliveryFeeId == 0) {
            const fee = deliveryMethodList.find(f => f.name === deliveryMethodSelected)
            if(fee && fee.DeliveryFeeID > 0) { deliveryFeeId = fee.DeliveryFeeID; }
          }  
          const json = await getLocationsByCustomer(customerID, lockedSide, deliveryMethodSelected, deliveryFeeId, totalOrder);
          
          if (json && json.AddressesAndFee !== undefined) {
            const formattedLocations = json.AddressesAndFee.map((c) => ({ ...c, name: `${c.AddressValue}${c.City ? `, ${c.City}`: '' }${c.CountryId ? `, ${c.CountryId}`: '' }`, value: c.CustomerId}));
            setLocationsList(formattedLocations);
            if(locationCustomerID > 0)
            {
              setDeliveryCustomerID(locationCustomerID);
            }
          } else {
            setLocationsList([]);
          }
      };

      loadLocations(deliveryMethodSelected, 0);      
      
      setFirstLoad(false);
    }
  },[date, locationCustomerID, deliveryMethodSelected, firstLoad, customerID, lockedSide])
  
  useEffect(()=>{
    if(totalOrder > 0) {
      loadLocations(deliveryMethodSelected, 0);
    }
  },[totalOrder])

  useEffect(()=>{
    if(defaultInstrument && instrument === '') {
      dropdownInstrumentChangeHandler({value:defaultInstrument});    
    }
    else
    {
      dropdownInstrumentChangeHandler({value:selectedtInstrument});       
    }
    if(defaultSettlementMethod && settlementMethod === '') {
      setSettlementMethod(defaultSettlementMethod);      
      dropdownMethodChangeHandler({value:defaultSettlementMethod}); 
    }
    else
    {
      setSettlementMethod(selectedSettlementMethod);
    }
  },[defaultInstrument, defaultSettlementMethod,settlementMethods])

  const onChangeTimeValue = (timeValue) => {
    if (!timeValue || !timeValue.isValid()) return;
    const hours = timeValue.hour().toString().padStart(2, '0');
    const minutes = timeValue.minute().toString().padStart(2, '0');
    setDeliveryTime(timeValue);
    updateDeliveryTime(`${hours}:${minutes}`);
  };

  const loadLocations = async(deliveryMethod, deliveryFeeId) =>{
    if(deliveryFeeId == 0) {
      const fee = deliveryMethodList.find(f => f.name === deliveryMethod)
      if(fee && fee.DeliveryFeeID > 0) { deliveryFeeId = fee.DeliveryFeeID; }
    }  
    const locationsResponse = await getLocationsByCustomer(customerID,lockedSide, deliveryMethod, deliveryFeeId, totalOrder);
      if (locationsResponse && locationsResponse.AddressesAndFee !== undefined) {
          const formattedLocations = locationsResponse.AddressesAndFee.map((c) => ({ ...c, name: `${c.AddressValue}${c.City ? `, ${c.City}`: '' }${c.CountryId ? `, ${c.CountryId}`: '' }`, value: c.CustomerId}));
          setLocationsList(formattedLocations);
      } else {
          setLocationsList([]);
    }
  }

  const dropdownLocationsChangeHandler = (item) => {
    if (item || item.value) {
      setDeliveryCustomerID(Number(item.value ?? item));
      updateDeliveryTo(item.value, item.name, item.DeliveryFee, item.ContactName);
    }
  };

    const dropdownDeliveryMethodChangeHandler = (item) => {
      if(item.value && item.value !== 'select')
      {
        setDeliveryCustomerID(0);
        loadLocations(item.value, item.DeliveryFeeID);        
        setShowCompanyAddress((lockedSide.toLowerCase() === 'buy' && item.value.toLowerCase().includes('sends currency')));
        setIsPartnerPickUp((lockedSide.toLowerCase() === 'buy' && item.value.toLowerCase().includes('partner pick')));
        setDeliveryMethod(item.value);
        updateDeliveryMethod(item);
      }
      else
      {
        setLocationsList([]);
        setDeliveryCustomerID(0);
      }
    }

    const getCrossRate = async(ccy) =>{
      const responseRate = await getBNCrossRate(ccy);
      return responseRate.Rate?responseRate.Rate:0;      
    }
    
  const dropdownBuyCurrencyChangeHandler = async (item) => {
      if(item.value && item.value !== '')
      {
        let rate = 0;
        if(item.value !== baseCCy)
        {
          rate = await getCrossRate(item.value);
        }

        setBuyCurrency(item.value);
        setCrossRate(rate);
        updateBuyCurrency(item, rate);
      }
    }

  const onBlurCrossRate = () =>{
    updateBuyCurrency({value:buyCurrencySelected}, crossRate);
  }

  const dropdownInstrumentChangeHandler = async (item) => {
    if(item.value && item.value !== '')
    {
      let methodsFilter = settlementMethods[item.value];
      if(methodsFilter === undefined || item.value === "Client's Vostro Account"){
        methodsFilter = [];
      }

      setInstrument(item.value);
      setSettlementMethodsFilter(methodsFilter);
      updateField('Instrument',item.value);
    }
  }

    const dropdownMethodChangeHandler = async (item) => {
    if(item.value && item.value !== '')
    {
      setSettlementMethod(item.value);
      updateField('SettlementMethod',item.value);
    }
  }

return (
    <>
      <div className="uk-grid">
            

            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Delivery Method:'}</label>
                <DynamicSelect
                    className={formatValidSelect(validations.DeliveryMethod)}
                    listHasPlaceholder={true}
                    data={deliveryMethodList}
                    objValue={{value:deliveryMethod}}
                    getValue={dropdownDeliveryMethodChangeHandler}/>                
            </div>
            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Customer:'}</label>
                <input className="uk-input" id="customer-name" value={customerName} type="text" disabled={true} />
            </div>

            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{showCompanyAddress ? 'Delivery From:':(isPartnerPickUp?'Pick up from':'Delivery To:')}</label>
                <DynamicSelect
                    className={formatValidSelect(validations.DeliveryCustomerID)}
                    listHasPlaceholder={true}
                    data={locationsList}
                    objValue={{value:deliveryCustomerID}}
                    usedInBNotes={true}
                    getValue={dropdownLocationsChangeHandler}/>      
            </div>

            <div  className="uk-width-1-4 uk-form-controls">
                <label className="uk-form-label">{'Settlement Currency:'}</label>
                 <DynamicSelectWithSearch key={'set-ccy'}
                    id={'set-ccy'}
                    className={formatValidSelect(validations.BuyCurrency)}
                    data={settlementCurrenciesList}
                    placeholder='Select a currency...'
                    getValue={dropdownBuyCurrencyChangeHandler}
                    objValue={{value:buyCurrency}}/>              
            </div>
            <div  className="uk-width-1-4 uk-form-controls">
              {buyCurrency !== baseCCy && <>
                <label className="uk-form-label">{'Rate:'}</label>
                <NumberInput id={`crossrate`} key={`crossrate`} className={formatValidInput(baseCCy===buyCurrency || crossRate >0)} value={crossRate} 
                  scale={ratePrecision} onBlur={onBlurCrossRate} onChange ={(event) => {setCrossRate(event.target.value);}} type="Rate"/>    
                </>
              }          
            </div>

            <div className="uk-width-1-4 uk-form-controls">
                <label className="uk-form-label">{isPartnerPickUp?'Pick up date:':'Release Date:'}</label>
                <DatePicker disabledDays={[0,6]} 
                    className={formatValidInput(validations.DeliveryDate)}                     
                    startDate={startDate} 
                    onDayChange={handleChangeDeliveryDate}
                    disabled={showCompanyAddress}
                    value={deliveryDate}/>
            
            </div>
            <div className="uk-width-1-4 uk-form-controls">
              {/*
                <label className="uk-form-label">{isPartnerPickUp?'Pick up time:':'Delivery Time:'}</label>
                 <TimePicker id={'tp-delivery-time'} className={formatValidInput(validations.DeliveryTime)}
                onChangeTime={onChangeTimeValue} value={deliveryTime} disabled={showCompanyAddress}
                />
                */}
            </div>

            <div  className="uk-width-1-4 uk-form-controls">
                <label className="uk-form-label">{'Settlement Instrument:'}</label>
                 <DynamicSelect key={'set-inst'}
                    id={'set-inst'}
                    className={formatValidSelect(validations.Instrument)}
                    data={instruments}
                    placeholder='Select an instrument...'
                    getValue={dropdownInstrumentChangeHandler}
                    objValue={{value:instrument}}/>              
            </div>

            <div  className="uk-width-1-4 uk-form-controls">
                <label className="uk-form-label">{'Settlement Method:'}</label>
                 <DynamicSelect key={'set-methods'}
                    id={'set-methods'}
                    className={formatValidSelect(validations.SettlementMethod)}
                    data={settlementMethodsFilter}
                    placeholder='Select settlement method...'
                    getValue={dropdownMethodChangeHandler}
                    objValue={{value:settlementMethod}}/>              
            </div>

            {showCompanyAddress && <div  className="uk-width-1-2 uk-form-controls">
              <label className="uk-form-label">{'Delivery To:'}</label>
                <input className="uk-input" id="company-address" value={companyAddress} type="text" disabled={true} />
              </div>}

           
      </div>
      <Divider style={{marginBottom:'10px', marginTop:'10px'}}/>
    </>
  );
}

export default OrderInformationHeader